import { db, admin } from "common/config/Firebase"
import createIds from "./createIds";

const indicatorsByDay = db.collection('indicatorsByDay')
const indicatorsByMonth = db.collection('indicatorsByMonth')

const updateInvoice = (invoice, oldInvoice) => {
    let increment = 0;
    
    if (invoice.payed && !oldInvoice.payed) {
        increment = isNaN(invoice.totalPrice) ? 0 : Number(invoice.totalPrice)
    }

    else if (!invoice.payed && oldInvoice.payed) {
        increment = isNaN(oldInvoice.totalPrice) ? 0 : 0 - Number(oldInvoice.totalPrice)
    }

    else if (invoice.payed && (invoice.totalPrice !== oldInvoice.totalPrice)) {
        increment = isNaN(invoice.totalPrice) || isNaN(oldInvoice.totalPrice) ? 0 : Number(invoice.totalPrice) - Number(oldInvoice.totalPrice)
    }

    incrementAmount(new Date(invoice.invoiceDate), increment)
}

const deleteInvoice = (invoice) => {
    if (!invoice.payed) {
        return
    }

    const increment = isNaN(invoice.totalPrice) ? 0 : 0 - Number(invoice.totalPrice)
    incrementAmount(new Date(invoice.invoiceDate), increment)
}

const incrementAmount = (date, amount) => {
    if (!amount) {
        return
    }

    const increment = admin.firestore.FieldValue.increment(amount)
    try {
        indicatorsByDay.doc(createIds.createIdByDay(date)).set({ amountInvoice: increment }, { merge: true })
        indicatorsByMonth.doc(createIds.createIdByMonth(date)).set({ amountInvoice: increment }, { merge: true })
    } catch (ex) {
        console.error("Error al actualizar el indicatorsByDay")
    }
}

export default {
    updateInvoice,
    deleteInvoice
}
